import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { useTranslation } from 'react-i18next';

export default function useCopyEDT() {
  const { notifyError, notifySuccess } = useNotification();
  const { t } = useTranslation(['emploiDuTemps']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: ({
      edtId,
      srcSchoolId,
      srcSchoolyearId,
      destSchoolId,
      mappings,
    }: {
      edtId: string;
      destSchoolId: string;
      destSchoolyearId: string;
      srcSchoolId: string;
      srcSchoolyearId: string;
      mappings: Array<{ from: string; to?: string }>;
    }) =>
      request(
        `/schoolyears/${srcSchoolyearId}/schools/${srcSchoolId}/emplois-du-temps/${edtId}/copy`,
        {
          method: 'POST',
          body: {
            mappings,
            schoolId: destSchoolId,
          },
        },
      ),

    onSuccess: (_, { destSchoolId, destSchoolyearId }) => {
      queryClient.invalidateQueries({
        queryKey: [destSchoolyearId],
      });
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY, destSchoolId],
      });
      notifySuccess({
        title: t('emploiDuTemps:messages.edt.copySuccess'),
      });
    },
    onError: () => {
      notifyError({
        title: t('emploiDuTemps:messages.edt.copyError'),
      });
    },
  });
  return mutateAsync;
}
